import React from 'react';

const DrawingBottomText = () => {
    return (
        <div>
            <div className="clear"/>
            <div id="component">
                <div className="body-l">
                    <div className="body-r">
                        <div>
                            <div>
                                <h1>XỔ SỐ MIỀN NAM - XSMN :</h1>
                                <p>&nbsp;</p>
                                <p>
                                    Xổ số kiến thiết Việt Nam phân thành 3 thị trường tiêu thụ (Bắc,
                                    Trung, Nam), bộ vé liên kết các tỉnh xổ số miền nam gồm 21 tỉnh từ
                                    Bình Thuận đến Cà Mau gồm:
                                </p>
                                <p>
                                    <br/>
                                    Thứ 2: (1) TP. HCM (xshcm), (2) Đồng Tháp (xsdt), (3) Cà Mau
                                    (xscm)
                                </p>
                                <p>
                                    Thứ 3: (1) Bến Tre (xsbt), (2) Vũng Tàu (xsvt), (3) Bạc Liêu
                                    (xsbl)
                                </p>
                                <p>
                                    Thứ 4: (1) Đồng Nai (xsdn), (2) Cần Thơ (xsct), (3) Sóc Trăng
                                    (xsst)
                                </p>
                                <p>
                                    Thứ 5: (1) Tây Ninh (xstn), (2) An Giang (xsag), (3) Bình Thuận
                                    (xsbth)
                                </p>
                                <p>
                                    Thứ 6: (1) Vĩnh Long (xsvl), (2) Bình Dương (xsbd), (3) Trà Vinh
                                    (xstv)
                                </p>
                                <p>
                                    Thứ 7: (1) TP. HCM (xshcm), (2) Long An (xsla), (3) Bình Phước
                                    (xsbp), (4) Hậu Giang (xshg)
                                </p>
                                <p>
                                    Chủ Nhật: (1) Tiền Giang (xstg), (2) Kiên Giang (xskg), (3) Đà Lạt
                                    (xsdl)
                                </p>
                                <p>&nbsp;</p>
                                <p>
                                    Cơ cấu thưởng của xổ số miền nam gồm 18 lô (18 lần quay số), Giải
                                    Đặc Biệt 2.000.000.000 vnđ / vé 6 chữ số loại 10.000đ.
                                </p>
                                <p>&nbsp;</p>
                                <p>
                                    * (1) = Đài 1, (2) = Đài 2, (3) = Đài 3 hay còn gọi là đài chính,
                                    đài phụ và đài phụ 3 trong cùng ngày căn cứ theo lượng tiêu thụ và
                                    có tính tương đối tùy từng khu vực. Trong tuần mỗi tỉnh phát hành
                                    1 kỳ vé riêng TP. HCM phát hành 2 kỳ. Từ "Đài" là do người dân
                                    quen gọi từ sau 1975&nbsp; mỗi chiều có 3 đài radio phát kết quả
                                    xổ số của 3 tỉnh, thứ 7 có 4 tỉnh phát hành.
                                </p>
                                <p>&nbsp;</p>
                                <p>
                                    * Phân vùng thị trường tiêu thụ khác với phân vùng địa giới hành
                                    chính, ví dụ như Bình Thuận thuộc Miền Trung nhưng lại thuộc bộ vé
                                    liên kết Xổ Số Miền Nam.
                                </p>
                                <p>&nbsp;</p>
                                <p style={{textAlign: "right"}}>
                                    Team Xổ Số THINHNAM - Miền Nam - XSMN
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clear"/>
        </div>

    );
};

export default DrawingBottomText;
